// Textos e regras compartilhados entre o cabecalho (TicketInfo) e a barra
// lateral (ContactDrawer) sobre as informacoes do cliente.

export const APARELHOS = {
  iphone: { rotulo: "iPhone", dica: "Celular do cliente: iPhone" },
  android: { rotulo: "Android", dica: "Celular do cliente: Android" },
};

export const ORIGENS = {
  sms_clt: "SMS CLT",
  sms_fgts: "SMS FGTS",
};

export const PRODUTOS = {
  consignado_clt: "CLT",
  fgts: "FGTS",
  ambos: "CLT+FGTS",
};

export const rotuloOrigem = (info) =>
  ORIGENS[info?.origem] ||
  (PRODUTOS[info?.produto] ? `Direto · ${PRODUTOS[info.produto]}` : "Direto");

export const tempoDesde = (iso, agora) => {
  if (!iso) return "";
  const min = Math.max(0, Math.floor((agora - new Date(iso).getTime()) / 60000));
  if (min < 1) return "agora";
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h${min % 60 ? ` ${min % 60}min` : ""}`;
  const d = Math.floor(h / 24);
  return d === 1 ? "1 dia" : `${d} dias`;
};

export const quandoConsultou = (iso, agora) => {
  if (!iso) return "";
  const dias = Math.floor((agora - new Date(iso).getTime()) / 86400000);
  if (dias <= 0) return "consultou hoje";
  if (dias === 1) return "consultou ontem";
  return `consultou há ${dias} dias`;
};

const hora = (d) =>
  d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

export const vistoPorUltimo = (ms, agora) => {
  if (!ms) return "";
  const d = new Date(ms);
  const hoje = new Date(agora);
  const ontem = new Date(agora - 86400000);
  if (d.toDateString() === hoje.toDateString()) return `visto por último hoje às ${hora(d)}`;
  if (d.toDateString() === ontem.toDateString()) return `visto por último ontem às ${hora(d)}`;
  return `visto por último em ${d.toLocaleDateString("pt-BR")} às ${hora(d)}`;
};

// { tipo: "online" | "offline" | "digitando", texto } ou null (sem informacao)
export const textoPresenca = (presenca, agora) => {
  if (!presenca?.status) return null;
  if (presenca.status === "composing") return { tipo: "digitando", texto: "digitando..." };
  if (presenca.status === "recording") return { tipo: "digitando", texto: "gravando áudio..." };
  if (presenca.status === "available") return { tipo: "online", texto: "online" };
  if (presenca.lastSeen) return { tipo: "offline", texto: vistoPorUltimo(presenca.lastSeen, agora) };
  return { tipo: "offline", texto: "offline" };
};
